import React, { useState, useEffect, useMemo, useRef } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import Form from "react-jsonschema-form";
import { Modal, ModalBody, ModalHeader, Card, CardBody, CardHeader, Table, Button, Label } from 'reactstrap';
import fields from "react-jsonschema-form-extras";

import CFormFields from "common/Form/CFormFields";
import { customFormats, transformErrors } from "common/validation";
import { notifier, http } from "common";

let allFields = Object.assign({}, fields, CFormFields);

const TABLEACTION_ADD = 'add';
const TABLEACTION_EDIT = 'edit';
const TABLEACTION_DEL = 'delete';
const TABLEACTION_MODAL_SUBMIT = 'modalsubmit';

const TABLEKEY_BUDGET_AUDIT = 'budgetAuditTable';
const TABLETITLE_BUDGET_AUDIT = 'Outstanding Audit Para Pertaining to ICCR Budget';

const TABLECOL_BUDGET_AUDIT = [ 
  {field: 'sno', title: 'S.no'},
  {field: 'year', title: 'Year'},
  {field: 'parano', title: 'Audit para no.'},
  {field: 'details', title: 'Details of Observation of Audit Para'},
  {field: 'actionmission', title: 'Action Taken by Mission'},
  {field: 'actioniccr', title: 'Action Required by ICCR'},
  {field: 'remarks', title: 'Remarks'},
];

const TESTDATA_BUDGET_AUDIT = [
  {id: 1, sno: 1, year: '2024-2025', parano: 1, details: 'details1', actionmission: 'action taken1', actioniccr: 'action required1', remarks: 'remarks1'},
  {id: 2, sno: 2, year: '2024-2025', parano: 2, details: 'details2', actionmission: 'action taken2', actioniccr: 'action required2', remarks: 'remarks2'},
  {id: 3, sno: 3, year: '2024-2025', parano: 3, details: 'details3', actionmission: 'action taken3', actioniccr: 'action required3', remarks: 'remarks3'},
  {id: 4, sno: 4, year: '2024-2025', parano: 4, details: 'details4', actionmission: 'action taken4', actioniccr: 'action required4', remarks: 'remarks4'},
  {id: 5, sno: 5, year: '2024-2025', parano: 5, details: 'details5', actionmission: 'action taken5', actioniccr: 'action required5', remarks: 'remarks5'},
  {id: 6, sno: 6, year: '2024-2025', parano: 6, details: 'details6', actionmission: 'action taken6', actioniccr: 'action required6', remarks: 'remarks6'},
  {id: 7, sno: 7, year: '2024-2025', parano: 7, details: 'details7', actionmission: 'action taken7', actioniccr: 'action required7', remarks: 'remarks7'},
  {id: 8, sno: 8, year: '2024-2025', parano: 8, details: 'details8', actionmission: 'action taken8', actioniccr: 'action required8', remarks: 'remarks8'},
];

const TABLE_FORMSCHEMA_BUDGET_AUDIT = {
  type: "object",
  required: ["year", "parano", "details", "actionmission", "actioniccr", "remarks"],
  properties: {
    id: {type: 'number', title: 'ID'},
    sno: {type: 'number', title: 'S.no'},
    year: {type: 'string', title: 'Year'},
    parano: {type: 'string', title: 'Audit para no.'},
    details: {type: 'string', title: 'Details of Observation of Audit Para'},
    actionmission: {type: 'string', title: 'Action Taken by Mission'},
    actioniccr: {type: 'string', title: 'Action Required by ICCR'},
    remarks: {type: 'string', title: 'Remarks'},
  },
};

const TABLE_FORMUISCHEMA_BUDGET_AUDIT = {
  id: {'ui:widget': 'hidden'},
  sno: {'ui:readonly': true, 'ui:placeholder': 'S.no', 'ui:autofocus': true},
  year: {'ui:placeholder': 'Year', 'ui:autofocus': true},
  parano: {'ui:placeholder': 'Audit para no.', 'ui:autofocus': true},
  details: {'ui:placeholder': 'Details of Observation of Audit Para', 'ui:autofocus': true},
  actionmission: {'ui:placeholder': 'Action Taken by Mission', 'ui:autofocus': true},
  actioniccr: {'ui:placeholder': 'Action Required by ICCR', 'ui:autofocus': true},
  remarks: {'ui:placeholder': 'Remarks', 'ui:autofocus': true},
  "ui:field": "layout_grid",
  "ui:layout_grid": {
    "ui:row": [ {
      "ui:col": {
        md: "12",
        children: [ {
          "ui:row": [
            { "ui:col": { md: "3", children: ["sno"] } },
            { "ui:col": { md: "3", children: ["year"] } },
            { "ui:col": { md: "3", children: ["parano"] } },
            { "ui:col": { md: "3", children: ["details"] } },
          ],
        }, {
          "ui:row": [
            { "ui:col": { md: "3", children: ["actionmission"] } },
            { "ui:col": { md: "3", children: ["actioniccr"] } },
          ],
        }, ]
      },
    }, ]
  }
}

const TABLE_FORMDATA_BUDGET_AUDIT = {id: -1, sno: -1, year: '2024-2025', parano: 1, details: 'details', actionmission: 'action taken', actioniccr: 'action required', remarks: 'remarks'};


const ReactStrapTable = (props) => {
  const location = useLocation();
  const tableRef = useRef();

  const [rsTableColumn, setRsTableColumn] = useState([...TABLECOL_BUDGET_AUDIT]);
  const [rsTableData, setRsTableData] = useState([...TESTDATA_BUDGET_AUDIT]);

  const [rsTableFormSchema, setRsTableFormSchema] = useState({...TABLE_FORMSCHEMA_BUDGET_AUDIT});
  const [rsTableFormUISchema, setRsTableFormUISchema] = useState({...TABLE_FORMUISCHEMA_BUDGET_AUDIT});
  const [rsTableFormData, setRsTableFormData] = useState({...TABLE_FORMDATA_BUDGET_AUDIT});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModalOpen = () => { setIsModalOpen(!isModalOpen); };
  const handleModalOpened = () => {};

  const [modalTitle, setModalTitle] = useState(TABLETITLE_BUDGET_AUDIT);
  const [modalActionCaption, setModalActionCaption] = useState('Update');
  const [modalCancelCaption, setModalCancelCaption] = useState('Cancel');

  const handleTableAction = (tableAction, uiEvent, rowId) => {
    notifier.info(`${tableAction}, ${uiEvent}, ${rowId}`);
    switch (tableAction) {
      case TABLEACTION_ADD: {
	setRsTableFormData({...TABLE_FORMDATA_BUDGET_AUDIT});
	toggleModalOpen();
	break;
      };
      case TABLEACTION_EDIT: {
        const tmpRsTableData = rsTableData.filter((row) => row.id === rowId);
	if (tmpRsTableData.length > 0) { setRsTableFormData({...tmpRsTableData[0]}) };
	toggleModalOpen();
	break;
      };
      case TABLEACTION_DEL: {
        const tmpRsTableData = rsTableData.filter((row) => row.id !== rowId);
        setRsTableData(tmpRsTableData);
	break;
      };
      case TABLEACTION_MODAL_SUBMIT: {
        const tmpFormData = uiEvent.formData;
	if (tmpFormData.id === -1) {  // addition
	  tmpFormData.id = rsTableData.length + 1;
	  tmpFormData.sno = rsTableData.length + 1;
          setRsTableData([...rsTableData, tmpFormData]);
	} else { // update
          const tmpRsTableData = rsTableData.filter((row) => row.id !== tmpFormData.id);
          setRsTableData([...tmpRsTableData, tmpFormData]);
	}
	toggleModalOpen();
	break;
      };
      default: {}
    }
  };

  useEffect(() => {
  }, []);

  return (
    <div id="accordion " className="animated fadeIn">
      <Card className="mb-0 min-vh-50">
        <CardHeader id="headingOne">
          <h5 className="m-0 p-0">Table Test</h5>
        </CardHeader>
        <CardBody>
          <Label for="">{TABLETITLE_BUDGET_AUDIT}</Label>
          <div>
            <small>
            <Table bordered responsive size="sm">
              <thead>
                <tr>
                  {rsTableColumn.map((col) => ( <th key={col.title}>{col.title}</th> ))}
                  <th style={{colSpan: "2", textAlign: "center"}}>
                    <Button color='success' size='sm' onClick={(e) => handleTableAction(TABLEACTION_ADD, e, -1)}> 
                      <i className="fa fa-plus fa-fw" aria-hidden="true"></i>
                    </Button>
                  </th>
                </tr>
              </thead>
              <tbody>
                {rsTableData.map((row) => (
                  <tr key={row.id}>
                    {rsTableColumn.map((col) => ( <td key={`${col.field}_${row.id}_${row[col.field]}`}>{row[col.field]}</td> ))}
                    <td>
                      <Button color='primary' size='sm' onClick={(e) => handleTableAction(TABLEACTION_EDIT, e, row.id)}> 
		        <i className="fa fa-pencil fa-fw" aria-hidden="true"></i>
                      </Button>
		      <span> </span>
                      <Button color='danger' size='sm' onClick={(e) => handleTableAction(TABLEACTION_DEL, e, row.id)}> 
		        <i className="fa fa-times fa-fw" aria-hidden="true"></i>
                      </Button>
                    </td>
                  </tr>
		))}
              </tbody>
            </Table>
            <Modal isOpen={isModalOpen} toggle={toggleModalOpen} className={"modal-lg striped blue"} onOpened={handleModalOpened}>
              <ModalHeader toggle={toggleModalOpen}>{modalTitle}</ModalHeader>
              <ModalBody>
                <small>
                <Form
                  schema={rsTableFormSchema}
                  uiSchema={rsTableFormUISchema}
                  fields={allFields}
                  autocomplete="on"
                  formData={rsTableFormData}
                  customFormats={customFormats}
                  transformErrors={transformErrors}
                  noHtml5Validate={true}
                  showErrorList={false}
                  liveValidate={true}
                  onSubmit={(e) => { handleTableAction(TABLEACTION_MODAL_SUBMIT, e, -1) }}
                >
                  <div className="text-right col-sm-12">
                    <button type="submit" className="btn btn-sm btn-primary">{modalActionCaption}</button>
                    <button type="button" onClick={() => toggleModalOpen()} className="btn btn-sm btn-default" >{modalCancelCaption}</button>
                  </div>
                </Form>
                </small>
              </ModalBody>
            </Modal>
            </small>
          </div>
        </CardBody>
      </Card>
    </div >
  );
}

const TableTest = (props) => {
}

export default withRouter(ReactStrapTable);
